import { Input as InputAnt } from 'antd'
import styled from 'styled-components'
import { InputCss, FlagInputProps } from '../common/styled'

export const WrapperInputPassword = styled(InputAnt.Password)<FlagInputProps>`
	${InputCss}
`

export const WrapperInput = styled(InputAnt)<FlagInputProps>`
	${InputCss}
`
